import React from 'react';
import styled from 'styled-components';
import PerformanceFeeCharged from '../fees-and-pricing-components/performance-fee-charged';
import { Container, Label } from './styles';

const SContainer = styled(Container)`
  & > [class^="performance-fee-charged"] {
    margin-top: 8px;
  }
`;

export default function NoPerformanceFee() {
  return (
    <SContainer>
      <Label>Actual Performance Fee</Label>
      <PerformanceFeeCharged isPerformanceFeeCharged={false} />
    </SContainer>
  );
}
